"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ArrowDownLeftIcon, ArrowUpRightIcon } from "@heroicons/react/24/solid";
import { useContext, useEffect, useMemo, useState } from "react";
import RepCategoryPill from "../RepCategoryPill";
import UserPageRepModifyModal from "../modify-rep/UserPageRepModifyModal";
import GrantRepDialog from "../new-rep/GrantRepDialog";
import { getCanEditRep, getContributorLabel, type RepDirection } from "../UserPageRep.helpers";
export default function UserPageRepHeader(t0) {
  const $ = _c(75);
  const {
    overview,
    categories,
    profile,
    repDirection,
    onRepDirectionChange,
    loading
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const [visibleCount, setVisibleCount] = useState(5);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setVisibleCount(5);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== categories) {
    t2 = [categories];
    $[1] = categories;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  const visibleCategories = categories.slice(0, visibleCount);
  const hasMore = categories.length > visibleCount;
  let t3;
  if ($[3] !== activeProfileProxy || $[4] !== connectedProfile || $[5] !== profile) {
    t3 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[3] = activeProfileProxy;
    $[4] = connectedProfile;
    $[5] = profile;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const canEditRep = t3;
  const [editCategory, setEditCategory] = useState(null);
  const [isGrantRepOpen, setIsGrantRepOpen] = useState(false);
  const t4 = "tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-gradient-to-br tw-from-[#0f1014] tw-via-[#0A0A0C] tw-to-[#08090b] tw-shadow-2xl";
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-500/[0.05] tw-via-transparent tw-to-transparent tw-opacity-100" />;
    t6 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-[1px] tw-bg-gradient-to-r tw-from-transparent tw-via-blue-400/40 tw-to-transparent" />;
    t7 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    t8 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  const t9 = "tw-relative tw-p-6";
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Rep</h2>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = repDirection === "received" ? "What others recognize this identity for." : "What this identity recognizes others for.";
  let t12;
  if ($[12] !== t11) {
    t12 = <div className="tw-min-w-0">{t10}<p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">{t11}</p></div>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== overview || $[15] !== repDirection) {
    t13 = overview ? <div className="tw-flex tw-flex-shrink-0 tw-flex-col tw-items-end tw-text-right"><div className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Total Rep</div><div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-primary-400">{formatNumberWithCommas(overview.total_rep)}</div><span className="tw-mt-1 tw-text-sm tw-font-normal tw-text-iron-400">{formatNumberWithCommas(overview.contributor_count)}{" "}{getContributorLabel(repDirection, overview.contributor_count)}</span></div> : <div className="tw-flex tw-flex-shrink-0 tw-flex-col tw-items-end tw-text-right"><div className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Total Rep</div><div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-primary-400">—</div></div>;
    $[14] = overview;
    $[15] = repDirection;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-6">{t12}{t13}</div>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = repDirection === "received";
  let t16;
  if ($[20] !== onRepDirectionChange) {
    t16 = () => onRepDirectionChange("received");
    $[20] = onRepDirectionChange;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const t17 = `tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-p-0 tw-text-[13px] tw-font-medium tw-transition-colors tw-duration-200 ${repDirection === "received" ? "tw-text-iron-100" : "tw-text-iron-500 hover:tw-text-iron-300"}`;
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ArrowDownLeftIcon className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0" aria-hidden="true" />;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t15 || $[24] !== t16 || $[25] !== t17) {
    t19 = <button type="button" aria-pressed={t15} onClick={t16} className={t17}>{t18}Received</button>;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  const t20 = repDirection === "given";
  let t21;
  if ($[27] !== onRepDirectionChange) {
    t21 = () => onRepDirectionChange("given");
    $[27] = onRepDirectionChange;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  const t22 = `tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-p-0 tw-text-[13px] tw-font-medium tw-transition-colors tw-duration-200 ${repDirection === "given" ? "tw-text-iron-100" : "tw-text-iron-500 hover:tw-text-iron-300"}`;
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <ArrowUpRightIcon className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0" aria-hidden="true" />;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t20 || $[31] !== t21 || $[32] !== t22) {
    t24 = <button type="button" aria-pressed={t20} onClick={t21} className={t22}>{t23}Given</button>;
    $[30] = t20;
    $[31] = t21;
    $[32] = t22;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t19 || $[35] !== t24) {
    t25 = <div className="tw-flex tw-items-center tw-gap-4">{t19}{t24}</div>;
    $[34] = t19;
    $[35] = t24;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  const t26 = (visibleCategories.length > 0 || canEditRep && repDirection === "received") && <div className="tw-mt-6 tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-white/10 tw-pt-6"><div className="tw-mb-4 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Rep Categories</div><div className="tw-flex tw-flex-wrap tw-gap-3">{canEditRep && repDirection === "received" && <button type="button" onClick={() => setIsGrantRepOpen(true)} className="tw-group tw-inline-flex tw-h-11 tw-cursor-pointer tw-items-center tw-justify-center tw-gap-x-1.5 tw-rounded-lg tw-border tw-border-dashed tw-border-white/15 tw-bg-white/[0.03] tw-px-4 tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-all tw-duration-300 tw-ease-out hover:tw-border-white/20 hover:tw-bg-white/[0.05] hover:tw-text-iron-300"><svg className="-tw-ml-1 tw-h-4 tw-w-4 tw-text-iron-400 tw-transition-colors group-hover:tw-text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg><span>Add new</span></button>}{visibleCategories.map(cat => <RepCategoryPill key={cat.category} category={cat} canEdit={canEditRep && repDirection === "received"} onEdit={setEditCategory} direction={repDirection} />)}{hasMore && <button type="button" onClick={() => setVisibleCount(_temp)} className="tw-inline-flex tw-h-11 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-4 tw-text-sm tw-font-medium tw-text-iron-400 tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-out hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-text-white">+{categories.length - visibleCount} more</button>}</div></div>;
  let t27;
  if ($[37] !== canEditRep || $[38] !== categories.length || $[39] !== loading || $[40] !== repDirection) {
    t27 = categories.length === 0 && !loading && !(canEditRep && repDirection === "received") && <p className="tw-mb-0 tw-mt-6 tw-text-sm tw-font-normal tw-text-iron-500">{repDirection === "given" ? "This identity hasn't given any rep yet." : "This identity hasn't received any rep yet."}</p>;
    $[37] = canEditRep;
    $[38] = categories.length;
    $[39] = loading;
    $[40] = repDirection;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== canEditRep || $[43] !== categories.length || $[44] !== loading || $[45] !== repDirection) {
    t28 = categories.length === 0 && loading && !(canEditRep && repDirection === "received") && <div className="tw-mt-6 tw-flex tw-justify-center tw-py-4"><div className="tw-h-6 tw-w-6 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-iron-700 tw-border-t-iron-400" /></div>;
    $[42] = canEditRep;
    $[43] = categories.length;
    $[44] = loading;
    $[45] = repDirection;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t14 || $[48] !== t25 || $[49] !== t26 || $[50] !== t27 || $[51] !== t28) {
    t29 = <div className={t9}>{t14}{t25}{t26}{t27}{t28}</div>;
    $[47] = t14;
    $[48] = t25;
    $[49] = t26;
    $[50] = t27;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t29 || $[54] !== t5 || $[55] !== t6 || $[56] !== t7 || $[57] !== t8) {
    t30 = <div className={t4}>{t5}{t6}{t7}{t8}{t29}</div>;
    $[53] = t29;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== canEditRep || $[60] !== editCategory || $[61] !== profile || $[62] !== setEditCategory) {
    t31 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[59] = canEditRep;
    $[60] = editCategory;
    $[61] = profile;
    $[62] = setEditCategory;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== setIsGrantRepOpen) {
    t32 = () => setIsGrantRepOpen(false);
    $[64] = setIsGrantRepOpen;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== isGrantRepOpen || $[67] !== overview || $[68] !== profile || $[69] !== t32) {
    t33 = <GrantRepDialog profile={profile} overview={overview} isOpen={isGrantRepOpen} onClose={t32} />;
    $[66] = isGrantRepOpen;
    $[67] = overview;
    $[68] = profile;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t30 || $[72] !== t31 || $[73] !== t33) {
    t34 = <>{t30}{t31}{t33}</>;
    $[71] = t30;
    $[72] = t31;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  return t34;
}
function _temp(prev) {
  return prev + 10;
}